export default class RescuesController {
  constructor(resource) {
    this._resource = resource;
  }

  getRescuesByUserId(user_id) {
    return this._resource(`rescues/${user_id}`)
            .get()
            .then(res => res.body)
            .catch(error => { throw error })
  }

  createRescue(reward_id) {
    return this._resource(`rescues/${reward_id}`)
            .save()
            .then(res => res.body)
            .catch(error => { throw error })
  }
}
